export default {
	API: "/api",
	GOOGLE_API_KEY: "AIzaSyCb9Od1atIsQ6TIg7zXjab8vdnkqVcAHmc"
};
